// extracted by mini-css-extract-plugin
export var cardIcon = "_8l-5";
export var cardIconUnframed = "_8l-9";
export var checkboxCard = "_8l-0";
export var checkboxCardSelected = "_8l-4";
export var disabled = "_8l-2";
export var interactive = "_8l-1";
export var outerBorder = "_8l-3";
export var spacerMedium = "_8l-8";
export var spacerSmall = "_8l-7";
export var spacerXsmall = "_8l-6";